import React from 'react';
import { Drawer } from './shared/Drawer';
import NewCreatingPositionLoader from './position/NewCreatingPositionLoader';

const PlacedLoadingAnimation = ({ showModal = false }: { showModal?: boolean }) => {
	return showModal ? (
		<Drawer
			isOpen={true}
			isModal={showModal}
			onClose={() => {}}
			closeButton={false}
			backdropFilter="blur(10px)"
			backgroundColor="transparent"
			header={<></>}
			body={<NewCreatingPositionLoader showAnimation={true} />}
		/>
	) : null;
};

export default PlacedLoadingAnimation;
